import type { Group } from "../types";
import { GroupCreate } from "./GroupCreate";
import { GroupEdit } from "./GroupEdit";
import { GroupList } from "./GroupList";

export default {
  list: GroupList,
  create: GroupCreate,
  edit: GroupEdit,
  recordRepresentation: (record: Group) => record?.name,
  // "groups" is the underlying table; users see these as "Lists".
  options: { label: "Lists" },
};
